<template>
    <div>
      <h2>Select a preferred fulfillment option</h2>
      <form @submit.prevent="submitForm">
        <div class="inputs-cover">
          <div>
            <input type="checkbox" id="dropOff" value="Drop Off" v-model="selectedFulfillmentOptions">
            <label for="dropOff">Drop-Off & Pick-Up<span> (i)</span></label>
          </div>
          <div>
            <input type="checkbox" id="door2Door" value="Door2Door" v-model="selectedFulfillmentOptions">
            <label for="door2Door">Door-To-Door <span>(i)</span></label>
          </div>
        </div>
        <div class="pl-12 time-cover">
          <div>
            <label>Set Preferred Pick-up Time <span>(Applies to D2D Only</span></label>
            <select v-model="time">
              <option value="default">--Select--</option>
              <option value="developer">WAT</option>
              <option value="designer">UTC</option>
            </select>
          </div>
          <div>
            <label>Set Preferred Delivery Time  <span>(Applies to D2D Only</span></label>
            <select v-model="time">
              <option value="default">--Select--</option>
              <option value="developer">WAT</option>
              <option value="designer">UTC</option>
            </select>
          </div>
        </div>
        <Actions />
      </form>
    </div>
  </template>
    
  <script>
  import Actions from "@/components/EnterpriseCustomer/Settings/actions.vue";
  
  
  export default {
    name: 'FulfilmentOptions',
    components: {
          Actions,
      },
    data() {
      return {
        time: 'default',
        selectedFulfillmentOptions: []
      };
    },
    methods: {
      submitForm() {
      },
     
       back() {
        this.$router.go(-1)
      }
    }
  };
  </script>
  
  
  <style scoped>
  h2 {
    margin-left: 5%;
    margin-top: 5%;
    color: rgba(252, 194, 16, 1);
  }
  span{
    color: rgba(252, 194, 16, 1);
    font-size: 12px;
    font-weight: 400;
  }
  form {
    margin-top: 6%;
  }
  
  .inputs-cover {
    width: 70%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10%;
    padding-left: 5%;
  }
  .time-cover{
    width: 97%;
    display: flex;
    padding-left: 5%;
    justify-content: space-between;
  }
  
  .time-cover>div>label{
    color: rgba(16, 35, 62, 1);
    font-size: 14px;
    font-weight: 600;
  }
  select{
    width: 100%;
    border: 1px solid grey;
    border-radius: 8px;
    padding: 2%;
  }
  option{
    font-size: 14px;
    font-weight: 400;
    color: rgba(102, 116, 153, 1);
  }
  </style>